module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-allotment-wrapper"
    }
  }, [(!_vm.isLoadingData) ? _c('div', {
    staticClass: "tab-allotment-detail-id"
  }, [(_vm.hasAllotment) ? _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "margin-container",
    attrs: {
      "id": "header-value-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.idLote'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.allotmentId))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.qtdMovFin'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.allotment.countMovFin))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.qtdMovBan'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.allotment.countMovBan))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.periodo'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.dateRangeAllotment))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.critConcil'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.criteria))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.situacaoLote'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value",
    class: _vm.allotmentStatus.classe
  }, [_vm._v(_vm._s(_vm.allotmentStatus.valor))])])]), _c('div', {
    staticClass: "col-xs-12 margin-container",
    staticStyle: {
      "padding": "0px 10px 0px 10px"
    },
    attrs: {
      "id": "datatable-container"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.allotmentEntries,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })], 1)]) : _vm._e(), (!_vm.isLoadingData && !_vm.hasAllotment) ? _c('div', [_c('div', {
    staticClass: "vertical-center loading-center"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_vm._m(0), _c('br'), _c('p', {
    staticClass: "big-txt-allotment",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.lancamentoSemVinculo'))
    }
  }), (_vm.canConciliate) ? _c('button-primary', {
    staticClass: "primary",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabLotes.labels.concilarManualmente'),
      "faIcon": "",
      "id": "btnTabLoteConcManual",
      "clickFunction": _vm.goManualConcil,
      "customClass": "big-primary"
    }
  }) : _vm._e()], 1)])]) : _vm._e()]) : _vm._e(), (!_vm.isLoadingData && _vm.hasAllotment) ? _c('div', {
    attrs: {
      "id": "footer-monetary-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 monetary-container"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-value",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.vlMovFin'))
    }
  }), _c('h4', {
    staticClass: "detail-status",
    class: _vm.totalMovFin > 0 ? 'font-C' : _vm.totalMovFin < 0 ? 'font-D' : 'font-N'
  }, [_vm._v(_vm._s(_vm.totalMovFinTransformed))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-value",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.vlMovExt'))
    }
  }), _c('h4', {
    staticClass: "detail-status",
    class: _vm.totalMovExt > 0 ? 'font-C' : _vm.totalMovExt < 0 ? 'font-D' : 'font-N'
  }, [_vm._v(_vm._s(_vm.totalMovExtTransformed))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-value",
    staticStyle: {
      "margin-bottom": "0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.vlDivergencia'))
    }
  }), _c('tr', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    }
  }, [_c('td', [_c('h4', {
    staticClass: "detail-status",
    class: _vm.totalDivergencia != 0 ? 'font-D' : 'font-N'
  }, [_vm._v(_vm._s(_vm.totalDivergenciaTransformed))])]), (_vm.canGoToManualConcil) ? _c('td', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button-primary', {
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabLotes.labels.concilarManualmente'),
      "faIcon": "fa fa-handshake-o",
      "id": "btnTabLoteConcManualDivergence",
      "clickFunction": _vm.goManualConcil
    }
  })], 1) : _vm._e()])])])]), _c('div', {
    staticClass: "clear"
  })]) : (_vm.isLoadingData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10",
    attrs: {
      "id": "allotment-loading"
    }
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "id": "video-player",
      "loop": "loop",
      "autoplay": "autoplay"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3-sa-east-1.amazonaws.com/midias-banking/Lotes.mp4",
      "type": "video/mp4"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4140c414", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4140c414"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabAllotment/tabAllotment.pug
// module id = 1404
// module chunks = 0